import { GenerarReporteProductosPDF } from './ReporteCatalogoProductos';
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from '../../../componentes/contenedores/Card';
import Page from '../../../componentes/plantilla/Page';
import { EmpleadoFiltro, EmpleadoId } from '../../../configuracion/apiUrls';
import { useContextProducto } from '../../../contexto/producto/ProductoContext';
import TablaProductos from './TablaProductos';
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";

const HomeProductos = () => {
  const { listaProductos, setListaProductos, ActualizarLista} = useContextEmpleado();
  const [idEmpleado, setIdEmpleado] = useState('');
  const [errorIdEmpleado, setErrorIdEmpleado] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [errorFiltroEmpleado, setErrorFiltroEmpleado] = useState(false);
  
  const datos = {
    titulo: {
      titulo: "Página principal de productos",
      url: "/app/admin/productos",
      tituloUrl: "productos",
      nombreUrl: "productos"
    }
  }
    useEffect(() => {
      const regexEntero = /^\d+$/;
      if(idEmpleado.length>0){
        if (regexEntero.test(idEmpleado)){
          ActualizarLista(EmpleadoId + idEmpleado, setListaProductos);
          setErrorIdEmpleado(false)
        }else{
          setErrorIdEmpleado(true);
        }
      }
      else{
        setErrorIdEmpleado(false)
      }
    }, [idEmpleado])
  
  useEffect(() => {
    if(filtro.length>2){
      ActualizarLista(EmpleadoFiltro + filtro, setListaProductos);
      setErrorFiltroEmpleado(false)
    }
    else{
      setErrorFiltroEmpleado(true)
    }
  }, [filtro])

  return (
    <Page datos={datos}>
      <Card
            titulo="Modulo de gestión de productos"
        pie={
          <div className="d-flex flex-wrap gap-2">
            <Link to={"/app/admin/productos/nuevo"}>
              <button className="btn btn-info d-flex align-items-center gap-2 px-3 py-2 fw-bold shadow-sm rounded">
                <i className="fas fa-box"></i>
                <span>Nuevo Producto</span>
              </button>
            </Link>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2 px-3 py-2 fw-bold shadow-sm rounded"
              onClick={() => GenerarReporteProductosPDF(listaProductos)}
              title="Generar e imprimir catálogo de productos en PDF"
            >
              <i className="fas fa-file-pdf"></i>
              <span>Reporte PDF Productos</span>
            </button>
          </div>
        }
          >
            {/* Informacion general y creacion */}
            <div>
              <p className="card-text">
                Este módulo permite organizar, monitorear y administrar eficientemente todos los productos en inventario.
              </p>
            </div>
      </Card>
      <Card titulo="Lista de productos">
        <div className='row'>
          <div className="col-sm-12 col-lg-4">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Id</label>
              <input
                type="text"
                className={`form-control ${errorIdEmpleado ? "is-invalid" : ""}`}
                id="text"
                placeholder="Id del empleado"
                name="id"
                value={idEmpleado}
                onChange={e => setIdEmpleado(e.target.value)}
              />
            </div>
          </div>
          <div className="col-sm-12 col-lg-8">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Filtro</label>
              <input
                type="text"
                className={`form-control`}
                id="text"
                placeholder="Escriba el nombre o apellido"
                name="filtro"
                value={filtro}
                onChange={e => setFiltro(e.target.value)}
              />
            </div>
          </div>
        </div>
        <TablaProductos datos={listaProductos}></TablaProductos>
      </Card>
    </Page>
  )
}

export default HomeProductos;
